import { BasePetProfile, isDogProfile, PetProfile } from 'types/pet-profile';
import isEmpty from 'lodash/isEmpty';

type BaseFieldToCheck = keyof Pick<BasePetProfile, 'selectedAge' | 'selectedNeeds'>;
type SmartCollectionField = BaseFieldToCheck | 'selectedBreed';

const baseFieldsToCheck: BaseFieldToCheck[] = ['selectedAge', 'selectedNeeds'];

/**
 * This is a temporary additional check for the pet profile
 * reason: by definition isEmptyProfile will return false in case any field except selectedFoodTypes, or selectedWetFoodTypes or selectedTastePreferences has been changed
 * @see: https://petsdeli.atlassian.net/wiki/spaces/PT/pages/2581954577/Is+Pet+Profile+Empty+definition
 * It means if we change the name field only it is not an empty pet profile anymore
 * But on the BE side they expect to have at least breed or age or needs otherwise they want to have slug
 * So it seems isEmptyProfile is not correct function to use to determine payload for smart collection request
 *
 * @TODO:
 *  The input should be generated based on petProfile provided and the fallback slug on the level of getSmartCollection function
 *  Right now such things happens on the cases of usage of the function
 */
export const isProfileValidForSmartCollection = (petProfile: PetProfile) => {
  const fieldsToCheck: SmartCollectionField[] = isDogProfile(petProfile)
    ? [...baseFieldsToCheck, 'selectedBreed']
    : baseFieldsToCheck;

  return fieldsToCheck.some((fieldName) => !isEmpty(petProfile[fieldName]));
};
